import React from "react";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {Skeleton, Divider} from "antd";
import {PoolPaymentContractForm} from "./poolPaymentContractForm/PoolPaymentContractForm";
import {PoolPaymentContractsTable} from "./poolPaymentContractsTable/PoolPaymentContractsTable";

export const PoolPaymentContracts = ({poolId}) => {
    const stores = useStore();

    const [poolPaymentContractsLoading, poolPaymentContracts, _, __, refetch] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolPaymentContracts.bind(null, {
            poolId
        }),
        dependencies: [poolId]
    });

    // Aktif sözleşmeyi bul
    const activeContract =
        poolPaymentContracts?.data?.data?.find(contract => contract?.isActive) ||
        poolPaymentContracts?.data?.data?.find(contract => contract?.activityStatus === "active") ||
        poolPaymentContracts?.data?.data?.find(contract => contract?.endDate === null) ||
        {};

    if (poolPaymentContractsLoading) {
        return <Skeleton paragraph={{rows: 10, width: "100%"}} active={true} />;
    }

    return (
        <div style={{width: "100%"}}>
            <PoolPaymentContractForm
                activePoolPaymentContract={activeContract}
                poolId={poolId}
                onSuccess={async () => {
                    await refetch();
                }}
            />

            <PoolPaymentContractsTable
                poolPaymentContracts={poolPaymentContracts?.data?.data || []}
                size="small"
                refetch={async () => {
                    await refetch();
                }}
                showTitle={true}
                style={{marginTop: 20, marginBottom: 10}}
            />
        </div>
    );
};

export default PoolPaymentContracts;
